import { TiptapCommentBox } from "@circle-react/components/CommentsV3/CommentForm/TiptapCommentBox";
import type { Comment } from "@circle-react/types/Comment";
import type { Space } from "@circle-react/types/Space";
import { Form } from "@circle-react-shared/uikit/Form/Form";

interface CommentEditBoxProps {
  comment: Comment;
  space: Space;
  updateComment: (data: any) => void;
}

export const CommentEditBox = ({
  comment,
  space,
  updateComment,
}: CommentEditBoxProps) => (
  <div className="text-dark mb-1 whitespace-pre-line text-sm font-normal">
    <Form
      onSubmit={updateComment}
      defaultValues={{
        tiptap_body: comment.tiptap_body,
      }}
    >
      <TiptapCommentBox
        isEdit
        postId={comment.post_id}
        spaceId={space.id}
        autoFocus
      />
    </Form>
  </div>
);
